import * as React from 'react';
import * as S from "@styled";
import { FileReaderInput } from '../../../shared/components/FileReaderInput';
import { BpmnJsCliWrapper } from '../../model/BpmnJsCliWrapper'
import CustomModal from "shared/components/CustomModal";
export const ImportBpmnModal: React.FC<ImportBpmnModalProps> = (props) => {

    const [state, setState] = React.useState<ImportBpmnModalState>({
        fileValid: false
    });

    const handleFileRead = (fileName: string, fileContents: string) => {
        setState(state => ({ ...state, fileValid: !!fileContents, fileResult: fileContents, fileName: fileName }));
    }

    const handleImport = () => {
        const xml = state.fileResult;
        if (xml !== undefined) {
            BpmnJsCliWrapper.importXml(xml);
        }
        props.onHide();
    }

    return (
        <CustomModal
            label="import-bpmn"
            onClose={props.onHide}
            show={true}
            shouldCloseOnOverlayClick={true}
            modalTitle={<h2>{FRENDS.Localizations.Import} BPMN</h2>}
        >
            <S.WarningContainer>
                <div className="alert alert-warning">
                    <p className="alert-label">
                        <b>{FRENDS.Localizations.ImportingBpmnWillOverride}</b>
                        <br /><br />
                        {FRENDS.Localizations.LimitedBpmnSupport}
                    </p>
                </div>
            </S.WarningContainer>

            <S.FormGroup>
                <FileReaderInput label={FRENDS.Localizations.ChooseFile} onFileRead={handleFileRead} accept=".xml,.bpmn,.txt" />
                <span> {state.fileName} </span>
            </S.FormGroup>
            <S.ButtonGroup gap={12} $justifyContentEnd={true}>
                <S.Button id="close-modal-button" variant={S.ButtonType.bordered} onClick={props.onHide}>{FRENDS.Localizations.Close}</S.Button>
                <S.Button id="import-bpmn-button" disabled={!state.fileValid} onClick={handleImport}>{FRENDS.Localizations.Import}</S.Button>
            </S.ButtonGroup>
        </CustomModal>
    );
}

interface ImportBpmnModalProps {
    onHide: () => void;
}

interface ImportBpmnModalState {
    error?: any;
    fileName?: string;
    fileValid: boolean;
    fileResult?: string;
}